module.exports = __webpack_public_path__ + "static/media/saoyisao.4550c02a.png";